import styled, { css } from 'styled-components';
import BadgeOverlay from 'react-rainbow-components/components/BadgeOverlay';
import { CheckboxToggle } from 'react-rainbow-components';
import DatePickerFilter from 'components/DatePickerFilter';
import { color } from 'theme';
import { PURPLE_100, PURPLE_500 } from '../../../../../constants';

export const FilterButtonDropDown = styled.div`
    width: 21.25rem;
    height: 20rem;
    overflow: hidden;
    border-radius: 1rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    background: ${color('background.main')};
    box-shadow: 0px var(--Primitives-Number-scale-4, 4px) var(--Primitives-Number-scale-4, 4px) 0px rgba(0, 0, 0, 0.06), 0px var(--Primitives-Number-scale-8, 8px) var(--Primitives-Number-scale-24, 24px) 0px rgba(75, 70, 92, 0.16);
    transition: opacity 0.1s linear, visibility 0.1s linear;

    &:focus,
    &:active {
        outline: none;
    }
`;

export const StyledBadgeOverlay = styled(BadgeOverlay)`
    ${(props) => props.variant === 'brand' && css`
        & > span {
            background: ${PURPLE_100};
            color: ${PURPLE_500};
        }
    `};
`;

export const StyledDatePickerFilter = styled(DatePickerFilter)`
    width: unset;
    flex: 1;
    margin: 0 0.5rem 0 2.5rem;
`;

export const FailedToggleContainer = styled.div`
    display: flex;
    align-items: center;
    padding: 0.25rem 0.5rem 0.5rem 2.5rem;
`;

export const StyledFailedToggle = styled(CheckboxToggle)`
    label {
        font-size: 0.875rem;
        color: ${color('text.main')};
    }
`;
